module.exports = __webpack_public_path__ + "img/builds_pst:minimized.b19afc53.jpg";